import { type FieldType } from '../model/doctor/Doctor'

export function toCamelCase(displayName: string): string {
  const words = displayName.split(' ')
  let camelCase = words[0].toLowerCase()

  for (let i = 1; i < words.length; i++) {
    camelCase +=
      words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase()
  }

  return camelCase
}

export function getItemsWithSummaryReview(section: {
  fields: FieldType[]
}): string[] {
  return recursiveStep(section.fields)
}

const recursiveStep = (fields: FieldType[]): string[] => {
  const itemsWithSummaryReview: string[] = []

  if (!fields?.length) return []

  for (const field of fields) {
    if (field.summaryReview) {
      itemsWithSummaryReview.push(field.displayName)
    }

    // Only recurse if field has nested fields
    if (field.fields?.length) {
      const nestedItems = recursiveStep(field.fields)
      itemsWithSummaryReview.push(...nestedItems)
    }
  }

  return itemsWithSummaryReview
}

export function getColorByIndex(letter: string) {
  const colors = [
    'red',
    'orange',
    'green',
    'teal',
    'blue',
    'cyan',
    'purple',
    'pink'
  ]

  // Calculate the actual index, considering rotation
  const actualIndex = letter.charCodeAt(0) % colors.length

  // Return the color at the calculated index
  return colors[actualIndex] as any
}
